<template>
  <div class="header">
    <h1>{{ name }}</h1>
    <h2>{{ title }}</h2>
    <h3>{{ description }}</h3>
    <a href="/docs/JeffreyLuddenResume.pdf" download title="Download PDF (176 KB)" class="download-link grid grid-align-center"><span class="download-icon"></span><span class="download-text">Download&nbsp;</span>PDF <span class="download-size">&nbsp;(176 KB)</span></a>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    name: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  }
}
</script>

<style lang="scss" scoped>
.header {
    background: rgb(55,61,71);
    color: #fff;
    margin: 0;
    padding: 1.5rem;
    position: relative;
    & h1 {
      margin: 0.5rem 0 0.2rem;
    }
    & h2 {
      margin: 0.5rem 0 .5rem;
      font-size: 16px;
    }
    & h3 {
      margin: 0.5rem 0 .5rem;
      font-size: 14px;
    }
    & .download-link {
      position: absolute;
      top: 1rem;
      right: 1rem;
      background: #08f;
      color: #fff;
      border-radius: 15px;
      padding: 0.1rem 1rem;
      font-size: 12px;
      line-height: 30px;
      text-decoration: none;
      & .download-icon {
        background-image: url(../../assets/download-icon.png);
        background-repeat: no-repeat;
        background-size: 14px auto;
        width: 14px;
        background-position: left center;
        padding-right: 0.5rem;
      }
      &:hover {
        transform: scale(1.05);
      }
    }
}
@media (max-width: 640px) {
  .header {
    padding: 1.5rem 0.9rem;
  }
}
@media (max-width: 500px) {
  .header {
    & .download-text {
      display: none;
    }
    & .download-icon {
      padding-right: 0.3rem !important;
    }
  }
}
@media (max-width: 400px) {
  .header {
    & .download-size {
      display: none;
    }
  }
}
@media (max-width: 340px) {
  .header {
    & .download-link {
      padding: 0.1rem 0.6rem;
      line-height: 23px;
      border-radius: 12px;
      top: 0.8rem;
      right: 0.8rem;
    }
  }
}
</style>
